import React, { useState } from "react";
import { SiChatbot } from "react-icons/si";
import { FaTimes, FaPaperPlane } from "react-icons/fa";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    tgUsername: "",
    subject: "",
    message: "",
  });

  const [isFormOpen, setIsFormOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, tgUsername, subject, message } = formData;

    const MessageSent = `Sponsor Inquiry:\n\nName: ${name}\nEmail: ${email}\nTelegram: @${tgUsername}\nSubject: ${subject}\n\nMessage:\n${message}`;
    const BotToken = process.env.REACT_APP_TELEGRAM_BOT_TOKEN || "5228779518:AAEmEY8_dHJ4LXOefuPpWzXnEWHSnSrwA_0";
    const ChatID = process.env.REACT_APP_TELEGRAM_CHAT_ID || "-1002143952930";
    const msglinker = `https://api.telegram.org/bot${BotToken}/sendMessage`;

    try {
      await fetch(msglinker, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: ChatID, text: MessageSent }),
      });

      setSuccessMessage("Inquiry received! Abhishek will reply shortly.");
      setFormData({ name: "", email: "", tgUsername: "", subject: "", message: "" });

      setTimeout(() => setSuccessMessage(""), 3500);
      setIsFormOpen(false);
    } catch (error) {
      console.error(error);
      setSuccessMessage("Failed to send message. Please reach out via Telegram directly.");
    }
  };

  return (
    <div>
      {/* Floating Trigger Button */}
      <button
        onClick={() => setIsFormOpen(!isFormOpen)}
        className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 p-4 bg-slate-900 text-white rounded-full shadow-lg hover:bg-slate-800 hover:scale-105 active:scale-95 transition-all duration-200 z-40 border border-slate-700 focus:outline-hidden"
        title="Contact Maintainer"
        aria-label="Contact Developer"
      >
        <SiChatbot className="w-6 h-6" />
      </button>

      {/* Responsive Overlay Modal */}
      {isFormOpen && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-xs flex justify-center sm:justify-end items-end sm:items-end p-2 sm:p-4 z-50 overflow-y-auto">
          <div className="bg-white text-slate-900 rounded-3xl shadow-2xl w-full max-w-md border border-slate-200 overflow-hidden my-auto sm:my-0 max-h-[92vh] flex flex-col animate-in fade-in slide-in-from-bottom-5 duration-200">
            {/* Header */}
            <div className="bg-[#FAF9F6] p-4 sm:p-5 border-b border-slate-200 flex justify-between items-center shrink-0">
              <div>
                <h2 className="text-base sm:text-lg font-bold text-slate-900">Project Sponsorship & Inquiries</h2>
                <p className="text-xs sm:text-sm text-slate-500 font-medium">Direct message to Abhishek (@MrAbhi2k3)</p>
              </div>
              <button
                onClick={() => setIsFormOpen(false)}
                className="w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 flex items-center justify-center text-slate-600 transition"
                aria-label="Close modal"
              >
                <FaTimes className="w-4 h-4" />
              </button>
            </div>

            {/* Quick Greeting with Authentic Male Developer Photo */}
            <div className="p-4 sm:px-6 sm:pt-5 sm:pb-2 flex items-center gap-3.5 bg-white shrink-0">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=200&q=80"
                alt="Male software developer maintainer"
                className="w-12 h-12 rounded-2xl object-cover border border-slate-200 shadow-xs shrink-0"
              />
              <p className="text-xs sm:text-sm text-slate-700 font-medium leading-snug">
                Looking to sponsor a new feature or discuss software collaboration? Leave your brief below!
              </p>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-4 sm:p-6 space-y-3 sm:space-y-4 overflow-y-auto">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">Your Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Abhishek"
                    className="w-full px-3.5 py-2.5 text-sm bg-[#FAF9F6] border border-slate-200 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                    required
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">Work Email *</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="alex@company.com"
                    className="w-full px-3.5 py-2.5 text-sm bg-[#FAF9F6] border border-slate-200 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                    required
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">Telegram Handle</label>
                  <input
                    type="text"
                    name="tgUsername"
                    value={formData.tgUsername}
                    onChange={handleChange}
                    placeholder="@username"
                    className="w-full px-3.5 py-2.5 text-sm bg-[#FAF9F6] border border-slate-200 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                  />
                </div>
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">Subject *</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Feature Sponsorship"
                    className="w-full px-3.5 py-2.5 text-sm bg-[#FAF9F6] border border-slate-200 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                    required
                  />
                </div>
              </div>

              <div>
                <label className="block text-xs font-bold uppercase tracking-wider text-slate-600 mb-1">Sponsorship Details *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Share what project you'd like to back or your project requirements..."
                  rows={3}
                  className="w-full px-3.5 py-2.5 text-sm bg-[#FAF9F6] border border-slate-200 rounded-xl focus:outline-hidden focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 resize-none"
                  required
                />
              </div>

              <button
                type="submit"
                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-bold py-3.5 px-4 rounded-xl text-sm transition duration-200 flex items-center justify-center gap-2 shadow-xs active:scale-98"
              >
                <span>Send Inquiry</span>
                <FaPaperPlane className="text-xs" />
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Success notification */}
      {successMessage && (
        <div className="fixed bottom-5 left-5 right-5 sm:right-auto sm:bottom-6 sm:left-6 bg-slate-900 text-white text-sm font-semibold px-4 py-3 rounded-2xl shadow-xl z-50 border border-slate-700 flex items-center gap-2.5">
          <span className="w-2.5 h-2.5 rounded-full bg-emerald-400 shrink-0" />
          <span>{successMessage}</span>
        </div>
      )}
    </div>
  );
};

export default Contact;